var _excluded = ["items", "orientation", "dashProps"],
    _excluded2 = ["barColor", "displayBar", "children", "mark"],
    _excluded3 = ["barProps"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { Div, P, Span } from '@kizi/core-components';
import { IconV2 as Icon } from './IconV2';
export var IconMarker = function IconMarker(_ref) {
  var iconProps = _ref.iconProps,
      divProps = _ref.divProps;
  return /*#__PURE__*/React.createElement(Div, _extends({
    variant: "iconMarkerBig"
  }, divProps), /*#__PURE__*/React.createElement(Icon, iconProps));
};
export var DefaultMarker = function DefaultMarker(_ref2) {
  var stepNumber = _ref2.stepNumber;
  return /*#__PURE__*/React.createElement(Div, {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    variant: "timeline.marker"
  }, /*#__PURE__*/React.createElement(Span, {
    display: "block",
    variant: "timeline.markerNumber"
  }, stepNumber));
};
export var Timeline = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var items = _ref3.items,
      _ref3$orientation = _ref3.orientation,
      orientation = _ref3$orientation === void 0 ? 'vertical' : _ref3$orientation,
      dashProps = _ref3.dashProps,
      divProps = _objectWithoutProperties(_ref3, _excluded);

  var isVertical = orientation === 'vertical';

  var generateVariant = function generateVariant(variant) {
    return isVertical ? variant : "".concat(variant, "Horizontal");
  };

  return /*#__PURE__*/React.createElement(Div, _extends({
    display: "flex",
    position: "relative",
    flexDirection: isVertical ? 'column' : 'row',
    ref: ref
  }, divProps), items.map(function (item, index) {
    var body = item.body,
        iconProps = item.iconProps,
        title = item.title,
        iconDivProps = item.iconDivProps;
    var stepNumber = index + 1;
    var _body = body;
    var _title = title;

    if (typeof body === 'string') {
      _body = /*#__PURE__*/React.createElement(P, {
        variant: "footnoteRegular"
      }, body);
    }

    if (typeof title === 'string') {
      _title = /*#__PURE__*/React.createElement(P, {
        variant: "footnoteImportant"
      }, title);
    }

    var marker = iconProps ? /*#__PURE__*/React.createElement(IconMarker, {
      iconProps: iconProps,
      divProps: iconDivProps
    }) : /*#__PURE__*/React.createElement(DefaultMarker, {
      stepNumber: stepNumber
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, !isVertical && /*#__PURE__*/React.createElement(Div, {
      variant: "timeline.dashHorizontal"
    }), /*#__PURE__*/React.createElement(Div, {
      display: "flex",
      key: "step ".concat(index),
      variant: generateVariant('timeline.item')
    }, /*#__PURE__*/React.createElement(Div, {
      position: "relative"
    }, marker, isVertical && index < items.length - 1 && /*#__PURE__*/React.createElement(Div, _extends({
      variant: "timeline.dash"
    }, dashProps))), /*#__PURE__*/React.createElement(Div, {
      variant: generateVariant('timeline.textBlock')
    }, _title, _body)));
  }));
}); //Previous timeline below. Needs refactoring

export function OldTimeline(props) {
  return /*#__PURE__*/React.createElement(Div, _extends({
    display: "flex",
    flexDirection: "column"
  }, props));
}
export function TimelineItem(_ref4) {
  var barColor = _ref4.barColor,
      displayBar = _ref4.displayBar,
      children = _ref4.children,
      mark = _ref4.mark,
      restProps = _objectWithoutProperties(_ref4, _excluded2);

  var barProps = {
    bg: displayBar ? barColor || 'grey' : 'transparent'
  };
  return /*#__PURE__*/React.createElement(Div, _extends({
    display: "flex",
    flexDirection: "row"
  }, restProps), /*#__PURE__*/React.createElement(Div, {
    mr: 3,
    position: "relative"
  }, /*#__PURE__*/React.createElement(TimelineItemBar, {
    barProps: barProps
  }), mark), /*#__PURE__*/React.createElement(Div, null, children));
}
TimelineItem.defaultProps = {
  displayBar: true
};
export function TimelineItemBar(_ref5) {
  var barProps = _ref5.barProps,
      restProps = _objectWithoutProperties(_ref5, _excluded3);

  return /*#__PURE__*/React.createElement(Div, _extends({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "2em",
    height: "100%"
  }, restProps), /*#__PURE__*/React.createElement(Div, _extends({
    width: "1px",
    height: "100%"
  }, barProps)));
}
TimelineItemBar.defaultProps = {
  barProps: {
    bg: 'grey'
  }
};
export function TimeLineMark(props) {
  return /*#__PURE__*/React.createElement(Div, _extends({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    mt: "-1em",
    width: "2em",
    height: "2em",
    position: "absolute",
    top: "1em",
    bg: "blue",
    color: "white",
    borderRadius: "50%"
  }, props));
}